/* eslint-disable quotes */
export default {
  contactFormData: {
    en: {
      checkboxTitle: "Which Kairós DS'regional office do you want to contact?",
      candidateParagraph1:
        "KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L. is responsible for processing the personal data of the interested party and informs you that these data will be processed in accordance with the provisions of Regulation (EU) 2016/679, of April 27 (GDPR), and Organic Law 3/2018 , of December 5 (LOPDGDD), providing the following treatment information: </br>Purposes of the treatment and legitimacy: to involve the interested party in the personnel selection processes, carrying out an analysis of the applicant's profile with the aim of selecting the best candidate for the vacant position of the Responsible. Unequivocal consent through a clear action of the interested party. </br>Data conservation criteria: the data provided will be kept as long as its deletion is not requested. In this sense, and prior to deletion, the information will be blocked in such a way that it will not be available to companies. </br>Communication of the data: they may be processed and/or communicated to the companies that are members of our group, during the time of conservation of your curriculum and for the same purposes previously informed. </br>Rights of the Interested Party: Right to withdraw consent at any time; Right of access, rectification, portability and deletion of your data and limitation or opposition to its treatment; Right to file a claim with the Control Authority (www.aepd.es) if you consider that the treatment does not comply with current regulations. You can exercise these rights by sending a communication and proving your identity to the person in charge at Calle Caleruega, 102 28033 Madrid (Madrid). Email: <a href='mailto:lopd@kairosds.com' aria-label='Open email account wizard' class='highlighted' rel='noopener noreferrer'>lopd@kairosds.com</a>",
      selectButtons: {
        company: {
          text: "Company",
          ariaLabel: "Formulario para enviar datos si eres una empresa",
        },
        applicant: {
          text: "Candidate",
          ariaLabel: "Formulario para enviar datos si eres un candidato",
        },
        success: {
          text: "Innovation kairos ds",
          ariaLabel: "Botón de enlace a innovación",
        },
      },
      imageForm: {
        company: {
          srcImageMobile: "/assets/images/contact/plane-ilustration.svg",
          srcImageDesktop: "/assets/images/contact/plane-ilustration.svg",
          altImage: "Ilustración avión de papel",
          classImage: "decorationImageCompany",
        },
        applicant: {
          srcImageMobile: "/assets/images/contact/puzzle-mobile.svg",
          srcImageDesktop: "/assets/images/contact/puzzle-desktop.svg",
          altImage: "Ilustración avión de una pieza de puzzle",
          classImage: "decorationImageApplicant",
        },
        internship: {
          srcImageMobile: "/assets/images/contact/bulb-mobile.svg",
          srcImageDesktop: "/assets/images/contact/bulb-desktop.svg",
          altImage: "Ilustración de una bombilla",
          classImage: "decorationImageApplicantInternship",
        },
        succesForm: {
          srcImageMobile: "/assets/images/contact/success-mobile.svg",
          srcImageDesktop: "/assets/images/contact/success-desktop.svg",
          srcImageCheck: "/assets/images/contact/check-circle.svg",
          altImage: "Ilustración avión de papel hacia mujeres",
          altImageCheck: "Ilustración check-circle",
        },
      },
      titleForm: {
        company: {
          title: "How can we \n\n help you?",
          subTitle: "I am...",
        },
        applicant: {
          title: "Find your place \n\n with Kairós DS",
          subTitle: "I am...",
        },
        internship: {
          title: "Your interships \n\n with Kairós DS",
          subTitle: "I am...",
        },
      },
      errorMessages: {
        errorName: "Required field",
        errorEmail: "The email address is not valid",
        errorText: "Text field error",
        errorPhone: "The phone is not valid",
        errorLinkedin: "This information is required",
        errorLocation: "Choose witch geography do you want to contact",
        errorTerms: "You must accept the legal terms and conditions",
        errorDataRequired: "This information is required",
        errorRequiredCenter: "We need one training center",
        errorLinkedinOrCV: "We need to know your linkedin and/or your resume",
      },
      blurMessages: {
        blurName: "Required field",
        blurDataRequired: "This information is required",
      },
      submit: "Send",
      sent: "Sent",
      sentText: "Successfully",
      errortext: "Error: Please check the errors shown in the form",
      success: "We will contact you shortly.",
      question: "Would you like to know more about us?",
      textButtonMore: "INNOVATION KAIROS DS",
      redirectButtonApplicant: "Join Us",
      redirectButtonCompany: "About Us",
      maxFileMessage: "Maximum file size",
      maxFile: "500KB",
      config: [
        {
          type: "text",
          name: "name",
          label: "Name and surname",
        },
        {
          type: "text",
          name: "email",
          label: "Email",
        },
        {
          type: "tel",
          name: "phone",
          label: "Telephone",
          phoneCodeSelected: "+34",
          validations: ["phone"],
        },
        {
          type: "text",
          name: "organization",
          label: "Company",
        },
        {
          type: "text",
          name: "etsit",
          label: "ETSIT Cátedra",
        },
        {
          type: "text",
          name: "center",
          label: "In which training center do you study?",
        },
        {
          type: "text",
          name: "linkedin",
          label: "LinkedIn url",
        },
        {
          type: "textarea",
          name: "message",
          label: "Message (Tell us about yourself)",
        },
        {
          type: "attachment",
          name: "attachment",
          label: "Attach your resume in PDF",
          labelCompany: "You can attach PDF documents",
        },
        {
          type: "checkbox",
          name: "candidateTerms",
          label:
            "I have read and accept the <a href='/en/basic-information-on-data-protection.html' aria-label='Abre la pagina basic-information-on-data-protection.html' class='highlighted' target='_blank' rel='noopener noreferrer'>basic information on data protection</a>, as well as the additional information detailed in the <a href='/en/privacy-data-protection-policy.html' aria-label='https://kairosds.com/es/privacy-data-protection-policy' target='_blank' class='highlighted' rel='noopener noreferrer'>Privacy and Data Protection Policy. *</a>",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "candidateTerms2",
          label:
            "I agree to receive newsletters about the activities of: KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L.</br></br>* If the box is not checked, it will not be possible to proceed with the management of your request. ",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "companyTerms",
          label:
            "I have read and accept the <a href='/en/basic-information-on-data-protection.html' aria-label='Abre la pagina basic-information-on-data-protection.html' class='highlighted' target='_blank' rel='noopener noreferrer'>basic information on data protection</a>, as well as the additional information detailed in the <a href='/en/privacy-data-protection-policy.html' aria-label='https://kairosds.com/es/privacy-data-protection-policy' class='highlighted' target='_blank' rel='noopener noreferrer'>Privacy and Data Protection Policy. *</a>",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "companyTerms2",
          label:
            "I agree to receive newsletters about the activities of: KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L.</br></br>* If the box is not checked, it will not be possible to proceed with the management of your request. ",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "etsit",
          label: "ETSIT Cathedra",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "otherCenter",
          label: "Other:",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "spain",
          label: "Spain",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "mexico",
          label: "Mexico",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "peru",
          label: "Peru",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "asia",
          label: "Asia",
          group: "checkboxCountry",
        },
      ],
      messageText: "I am interested in an internship with Kairos.",
    },
    es: {
      checkboxTitle: "¿Con qué geografía de Kairós DS quieres contactar?",
      candidateParagraph1:
        "KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L. es el Responsable del tratamiento de los datos personales del interesado y le informa de que estos datos se tratarán de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD), facilitándole la siguiente información del tratamiento: </br>Fines del tratamiento y legitimación: hacer partícipe al interesado en los procesos de selección de personal, llevando a cabo un análisis del perfil del solicitante con el objetivo de seleccionar al mejor candidato para el puesto vacante del Responsable. Consentimiento inequívoco mediante una clara acción del interesado. </br>Criterios de conservación de los datos: los datos proporcionados se conservarán mientras no se solicite su supresión. En este sentido y, previamente a la supresión, se procederá al bloqueo de la información de tal manera que no estará disponible para las empresas. Comunicación de los datos: se podrán tratar y/o comunicar a las empresas integrantes de nuestro grupo, durante el tiempo de conservación de su currículum y para los mismos fines antes informados. </br>Derechos que asisten al Interesado: Derecho a retirar el consentimiento en cualquier momento; Derecho de acceso, rectificación, portabilidad y supresión de sus datos y de limitación u oposición a su tratamiento; Derecho a presentar una reclamación ante la Autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente. Puede ejercer estos derechos enviando una comunicación y acreditando su identidad al Responsable en Calle Caleruega, 102 28033 Madrid (Madrid). E-mail: <a href='mailto:lopd@kairosds.com' aria-label='Open email account wizard' class='highlighted' rel='noopener noreferrer'>lopd@kairosds.com</a>",
      selectButtons: {
        company: {
          text: "Empresa",
          ariaLabel: "Formulario para enviar datos si eres una empresa",
        },
        applicant: {
          text: "Candidato",
          ariaLabel: "Formulario para enviar datos si eres un candidato",
        },
        success: {
          text: "Innovación kairos ds",
          ariaLabel: "Botón de enlace a innovación",
        },
      },
      imageForm: {
        company: {
          srcImageMobile: "/assets/images/contact/plane-ilustration-mobile.svg",
          srcImageDesktop: "/assets/images/contact/plane-ilustration.svg",
          altImage: "Ilustración avión de papel",
          classImage: "decorationImageCompany",
        },
        applicant: {
          srcImageMobile: "/assets/images/contact/puzzle-mobile.svg",
          srcImageDesktop: "/assets/images/contact/puzzle-desktop.svg",
          altImage: "Ilustración avión de una pieza de puzzle",
          classImage: "decorationImageApplicant",
        },
        internship: {
          srcImageMobile: "/assets/images/contact/bulb-mobile.svg",
          srcImageDesktop: "/assets/images/contact/bulb-desktop.svg",
          altImage: "Ilustración de una bombilla",
          classImage: "decorationImageApplicantInternship",
        },
        succesForm: {
          srcImageMobile: "/assets/images/contact/success-mobile.svg",
          srcImageDesktop: "/assets/images/contact/success-desktop.svg",
          srcImageCheck: "/assets/images/contact/check-circle.svg",
          altImage: "Ilustración avión de papel hacia mujeres",
          altImageCheck: "Ilustración check-circle",
        },
      },
      titleForm: {
        company: {
          title: "¿En qué te \n\n podemos ayudar?",
          subTitle: "Soy...",
        },
        applicant: {
          title: "Encuentra tu lugar \n\n con Kairós DS",
          subTitle: "Soy...",
        },
        internship: {
          title: "Tus prácticas \n\n en Kairós DS",
          subTitle: "Soy...",
        },
      },
      errorMessages: {
        errorName: "Campo obligatorio",
        errorEmail: "Introduce un email válido",
        errorText: "Error en el campo de texto",
        errorPhone: "Introduce un teléfono válido",
        errorLinkedin: "Introduce una url válida",
        errorLocation: "Elige con qué equipo quieres contactar",
        errorTerms:
          "Para continuar tienes que aceptar los términos y condiciones",
        errorDataRequired: "Este dato es obligatorio",
        errorRequiredCenter: "Necesitamos un centro formativo",
        errorLinkedinOrCV: "Necesitamos conocer tu linkedin y/o tu CV",
      },
      blurMessages: {
        blurName: "Campo obligatorio",
        blurDataRequired: "Este dato es obligatorio",
      },
      submit: "Enviar",
      sent: "Enviado",
      sentText: "Enviado con éxito",
      errortext: "Error: Por favor, revisa los campos del formulario",
      success: "En breve nos pondremos en contacto contigo.",
      question: "¿Te gustaría saber más sobre nosotros?",
      textButtonMore: "INNOVACIÓN KAIROS DS",
      redirectButtonApplicant: "Únete",
      redirectButtonCompany: "Sobre Nosotros",
      maxFileMessage: "Tamaño máximo del archivo",
      maxFile: "500KB",
      config: [
        {
          type: "text",
          name: "name",
          label: "Nombre y apellidos",
        },
        {
          type: "text",
          name: "email",
          label: "Email",
        },
        {
          type: "tel",
          name: "phone",
          label: "Teléfono",
          phoneCodeSelected: "+34",
          validations: ["phone"],
        },
        {
          type: "text",
          name: "organization",
          label: "Organización",
        },
        {
          type: "text",
          name: "etsit",
          label: "ETSIT Cátedra",
        },
        {
          type: "text",
          name: "center",
          label: "¿En qué centro formativo estudias?",
        },
        {
          type: "text",
          name: "linkedin",
          label: "Url de tu LinkedIn",
        },
        {
          type: "textarea",
          name: "message",
          label: "Mensaje (Háblanos de ti)",
        },
        {
          type: "attachment",
          name: "attachment",
          label: "Adjunta tu CV en PDF",
          labelCompany: "Puedes adjuntar documentos PDF",
        },
        {
          type: "checkbox",
          name: "candidateTerms",
          label:
            "He leído y acepto la <a href='/es/basic-information-on-data-protection.html' aria-label='Abre la pagina basic-information-on-data-protection.html' class='highlighted' target='_blank' rel='noopener noreferrer'>Información básica sobre protección de datos</a>, así como la información adicional detallada en la <a href='/es/privacy-data-protection-policy.html' aria-label='https://kairosds.com/es/privacy-data-protection-policy' target='_blank' class='highlighted' rel='noopener noreferrer'>Política de privacidad y protección de datos. *</a>",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "candidateTerms2",
          label:
            "Acepto recibir boletines informativos sobre las actividades de: KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L.</br></br>* En caso de que no se marque la casilla no se podrá proceder a la gestión de su solicitud.",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "companyTerms",
          label:
            "He leído y acepto la <a href='/es/basic-information-on-data-protection.html' aria-label='Abre la pagina basic-information-on-data-protection.html' class='highlighted' target='_blank' rel='noopener noreferrer'>Información básica sobre protección de datos</a>, así como la información adicional detallada en la <a href='/es/privacy-data-protection-policy.html' aria-label='https://kairosds.com/es/privacy-data-protection-policy' target='_blank' class='highlighted' rel='noopener noreferrer'>Política de privacidad y protección de datos. *</a>",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "companyTerms2",
          label:
            "Acepto recibir boletines informativos sobre las actividades de: KAIRÓS DIGITAL ANALYTICS AND BIG DATA SOLUTIONS S.L.</br></br>* En caso de que no se marque la casilla no se podrá proceder a la gestión de su solicitud.",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "etsit",
          label: "ETSIT Cátedra",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "otherCenter",
          label: "Otro:",
          classes: "fieldset--full-width",
        },
        {
          type: "checkbox",
          name: "spain",
          label: "España",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "mexico",
          label: "México",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "peru",
          label: "Perú",
          group: "checkboxCountry",
        },
        {
          type: "checkbox",
          name: "asia",
          label: "Asia",
          group: "checkboxCountry",
        },
      ],
    },
  },
};
